import moment from 'moment';

const mapTypes = {
  person: 'физическое лицо',
  organisation: 'юридическое лицо',
};

const getAddressData = (address) => {
  if (address) {
    const { id, ...otherData } = address;
    return otherData;
  }

  return;
};

const transformContractorData = (
  values,
  counterpartiesTypes,
  editingCounterparty
) => {
  const currentType = counterpartiesTypes?.find((counterpartiesType) => {
    return mapTypes[values.contractorType] === counterpartiesType.name;
  });
  const data = Object.entries(values).reduce((acc, [key, value]) => {
    if (value?.key) {
      acc[key] = { id: +value?.key };
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});

  const { actualAddress, registrationAddress, cityBirth } = data;

  const commonInfo = {
    Receipt: data.receipt,
    RegistrationAddress: getAddressData(registrationAddress),
    Name: data.name,
    FirstName: data.firstName,
    SurName: data.surName,
    PatrName: data.patrName,
    Email: data.email,
    PhoneNumber: data.phoneNumber,
    Type: {
      Id: currentType?.id || 1,
    },
    Country: data.country,
    LandLordOffices: data.landLordOffices,
  };

  if (data.contractorType === 'person') {
    return {
      ...commonInfo,
      IndividualInfo: {
        id: editingCounterparty?.individualInfo?.id || 0,
        PassportSeries: data.passportSeries,
        PassportNumber: data.passportNumber,
        PassportIssued: data.passportIssued,
        PassportSubDivision: data.passportSubDivision,
        PassportDate: data.passportDate
          ? moment(data.passportDate).format()
          : undefined,
        DateBirth: data.dateBirth ? moment(data.dateBirth).format() : undefined,
        CityBirth: getAddressData(cityBirth),
      },
    };
  }
  if (data.contractorType === 'organisation') {
    return {
      ...commonInfo,
      LegalEntityInfo: {
        Id: editingCounterparty?.legalEntityInfo?.id || 0,
        Inn: data.INN,
        Ogrn: data.OGRN,
        Okp: data.OKP,
        Kpp: data.KPP,
      },
      ActualAddress: getAddressData(actualAddress),
    };
  }
};

export default transformContractorData;
